import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LoyaltyProgramCategory } from '../models';

@Pipe({
  name: 'getPLCategoryName',
})
export class GetCategoryNamePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(categories?: LoyaltyProgramCategory[]): string {
    if (categories && categories.length > 1) {
      return this.translateService.instant('components.loyaltyGetCategoryName.labels.titleWithMore', {
        value: categories[0].name,
        count: categories.length - 1,
      });
    }

    return categories?.[0]?.name ?? 'unknown';
  }
}
